import React, { useState, useEffect, use } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo_white from "../../assets/logo_white.png";
import logo_coloured from "../../assets/logo_coloured.png";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = isMobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isMobileOpen]);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/products', label: 'Products' },
    { path: '/blog', label: 'Blog' },
    { path: '/careers', label: 'Careers' },
    { path: '/contact', label: 'Contact' },
  ];

  // checks for the page and sets the logo accordingly.
  const {pathname} = useLocation();
  const logo = pathname === '/' ? logo_white : logo_coloured;

  return (
    <header className={`navbar ${isScrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__inner container">
        <Link to="/" className="navbar__logo" aria-label="Britenz Global Home">
          <img
              className="navbar__logo-image"
              src={isScrolled ? logo_coloured : logo}
              alt="logo"
            />
        </Link>

        <nav className={`navbar__nav ${isMobileOpen ? 'navbar__nav--open' : ''}`}>
          {navLinks.map(({ path, label }) => (
            <Link
              key={path}
              to={path}
              className={`navbar__link ${location.pathname === path ? 'navbar__link--active' : ''}`}
            >
              {label}
            </Link>
          ))}
          <Link to="/contact" className="btn btn--primary navbar__cta-mobile">
            Get Started
          </Link>
        </nav>

        <Link to="/contact" className="btn btn--primary navbar__cta">
          Get Started
        </Link>

        <button
          className={`navbar__hamburger ${isMobileOpen ? 'navbar__hamburger--open' : ''}`}
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          aria-label="Toggle navigation menu"
          aria-expanded={isMobileOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {isMobileOpen && (
        <div className="navbar__overlay" onClick={() => setIsMobileOpen(false)} />
      )}
    </header>
  );
};

export default Navbar;
